module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm06"
    }
  }, [_c('p', {
    staticClass: "auth"
  }, [_vm._v("“And the woman was arrayed in purple and scarlet color, and decked with gold and precious stones and pearls, having a golden cup in her hand . . . And upon her forehead was a name written, MYSTERY, BABYLON . . . MOTHER OF HARLOTS AND ABOMINATIONS OF THE EARTH.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T.")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELATION")]), _vm._v(",")]), _vm._v(" 17:4-5")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('img', {
    staticClass: "figure",
    attrs: {
      "alt": "",
      "src": "images/img_0002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("“The most absurd thing is to be conscious of the fact that human existence is unbearable, that the human condition is unbearable—intolerable—and nevertheless cling to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGENE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONESCO")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMOIRS")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('img', {
    staticClass: "figure",
    attrs: {
      "alt": "",
      "src": "images/img_0002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("“What is truth? What is a lie?”")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VA")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAMS")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENSÉES")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3994ad06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comments.vue
// module id = 78
// module chunks = 0